import api from "api";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { checkpoints } from "component/ChecklistMeter";
import _ from "lodash";
import "./style.scss";
import { Link } from "react-router-dom";
import { calculateProjectTimeframe } from "page/Initiative/Inside/Scaffold";

export default connect(stateMap)((props) => {
    const [isLoading, setIsLoading]     = useState(true);
    const [parameter, setParameter]     = useState(props.args);
    const [initiatives, setInitiatives] = useState([]);
    const mergedOrigCheckpoints = _.merge({}, checkpoints.event, checkpoints.research, checkpoints.research, checkpoints.default);
    const defaultKeys           = _.keys(checkpoints.default);
    const usedCheckpoints       = _.union(
        defaultKeys
        ,_.difference(
            _.intersection(
                _.keys(checkpoints.event),
                _.keys(checkpoints.research)
            )
            ,defaultKeys
        )
    );

    useEffect(() => {
        setParameter(props.args);
    }, [props.args])

    useEffect(() => {
        setIsLoading(true);

        api('/Monitor/GetListInitiativeStatus', 'get', parameter, 'Bearer ' + props.auth.token)
            .then(response => {
                setIsLoading(false);
                setInitiatives(response.initiatives)
            })
            .catch(() => {
                setIsLoading(false);
                setInitiatives([]);
            })

    }, [parameter]);

    return (
        <div className="component-list-initiative-status">
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>TimeFrame</th>
                        <th>Current <br/> Status</th>
                        <th>Total <br/> Participant</th>
                        <th>Checklist <br/> Meter</th>
                        {
                            usedCheckpoints.map((checkpoint) => (
                                <th className="checklist" key={checkpoint}>{mergedOrigCheckpoints[checkpoint].name}</th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        isLoading && 
                        <tr>
                            <td colSpan={20}>
                                <span className="skeleton"></span>
                            </td>
                        </tr>
                    }
                    {
                        !isLoading && initiatives.map((initiative) => (
                            <tr key={initiative.InitiativeID}>
                                <td>
                                    <Link to={`/initiative/${initiative.Slug}`} target="_blank">
                                        {initiative.Title}
                                    </Link>
                                </td>
                                <td>{initiative.InitiativeTypeTitle}</td>
                                <td>{calculateProjectTimeframe(initiative)}</td>
                                <td>{initiative.CurrentStatusTitle}</td>
                                <td style={{textAlign : 'center'}} >{initiative.TotalJoined}</td>
                                <td className="checklist-meter">
                                    <span className="bar-indicator" style={{
                                        width : `${ Math.min(100, Math.round(_.intersection(initiative.Checklist, usedCheckpoints).length / usedCheckpoints.length * 100)) }%`
                                    }}></span>
                                    {
                                        Math.min(100, Math.round(_.intersection(initiative.Checklist, usedCheckpoints).length / usedCheckpoints.length * 100)) 
                                    }%
                                </td>
                                {
                                    usedCheckpoints.map((checkpoint) => (
                                        <td  className="checklist" key={checkpoint}>{_.indexOf(initiative.Checklist, checkpoint) >= 0 ? 'Y' : ''}</td>
                                    ))
                                }
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}); 